import { Component, OnInit } from '@angular/core';
import { MDBModalRef } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-info-perfis',
  templateUrl: './info-perfis.component.html',
  styleUrls: ['./info-perfis.component.scss']
})
export class InfoPerfisComponent implements OnInit {

  constructor(
    public modalRef: MDBModalRef,
  ) { }

  ngOnInit(): void {
  }

  close() {
    return this.modalRef.hide();
  }

}
